import React, { createContext, useState } from "react";
import ReactDOM from "react-dom";
import { randomId } from "./portal.util";

export const PortalContext = createContext(undefined);

export const PortalProvider = ({ children }) => {
  const [portals, setPortals] = useState([]);

  const open = (element, options = {}) => {
    const {
      id: portalId = randomId(),
      appendTo = document.body,
      onClose,
    } = options;

    // Skip if the portal already exists
    if (portals.find(({ id }) => id === portalId)) return;

    if (!appendTo) {
      throw new Error("Trying to open a portal in a nonexistent DOM node");
    }

    const portal = {
      close: () => {
        close(portalId);
        onClose?.();
      },
    };

    const portalElement =
      typeof element === "function" ? element(portal) : element;

    const privatePortal = {
      element: portalElement,
      id: portalId,
      appendTo,
    };

    setPortals((oldPortals) => [...oldPortals, privatePortal]);
  };

  const close = (portalId) => {
    setPortals((oldPortals) => oldPortals.filter(({ id }) => id !== portalId));
  };

  return (
    <PortalContext.Provider value={{ open }}>
      {children}
      {portals.map(({ element, appendTo, id }) => (
        <React.Fragment key={id}>
          {ReactDOM.createPortal(element, appendTo)}
        </React.Fragment>
      ))}
    </PortalContext.Provider>
  );
};
